import { ActionButton, Button, formatExternalUrl } from "@octopusdeploy/design-system-components";
import * as React from "react";
import { useDispatch } from "react-redux";
import { actions as dialogActions } from "~/components/Dialog/store/index";
import { DialogLayout } from "~/components/DialogLayout/DialogLayout";
interface LicenseLimitReachedDialogLayoutProps {
    limitType: "Spaces" | "Workers";
    onClose: () => void;
    onActionClick?: () => void;
}
const LicenseLimitReachedDialogLayout: React.FC<LicenseLimitReachedDialogLayoutProps> = (props) => {
    const { onActionClick } = props;
    const notifyActionClick = React.useCallback(() => {
        if (onActionClick) {
            onActionClick();
        }
    }, [onActionClick]);
    const loadMoreInfo = (<Button key={"unlock-more-" + props.limitType} label={"Unlock more " + props.limitType} href={formatExternalUrl("Upgrade" + props.limitType)} external={true} importance="primary" onClick={() => {
            notifyActionClick();
        }}/>);
    const cancel = <ActionButton key="Cancel" label="Cancel" onClick={() => close()}/>;
    return (<DialogLayout title={`You've hit your ${props.limitType} limit...`} actions={[cancel, loadMoreInfo]} busy={null} errors={null} closeDialog={() => close()} additionalActions={[]}>
            <div>Want to add more? You'll need to upgrade your licence. Click to see your upgrade options and get a quote.</div>
        </DialogLayout>);
    function close() {
        props.onClose();
        notifyActionClick();
    }
};
LicenseLimitReachedDialogLayout.displayName = "LicenseLimitReachedDialogLayout"
interface LimitReachedDialogProps {
    onActionClick?: () => void;
}
type SpaceLimitReachedDialogLayoutProps = LimitReachedDialogProps;
export function SpaceLimitReachedDialogLayout(props: SpaceLimitReachedDialogLayoutProps) {
    const closeDialogs = useCloseAllDialogs();
    return <LicenseLimitReachedDialogLayout limitType={"Spaces"} onActionClick={props.onActionClick} onClose={closeDialogs}/>;
}
type WorkerLimitReachedDialogLayoutProps = LimitReachedDialogProps;
export function WorkerLimitReachedDialogLayout(props: WorkerLimitReachedDialogLayoutProps) {
    const closeDialogs = useCloseAllDialogs();
    return <LicenseLimitReachedDialogLayout limitType={"Workers"} onActionClick={props.onActionClick} onClose={closeDialogs}/>;
}
function useCloseAllDialogs() {
    const dispatch = useDispatch();
    return React.useCallback(() => {
        dispatch(dialogActions.closeAll());
    }, [dispatch]);
}
